/* eslint-disable semi */
/**
 * * Created by Simon Julius on 08/04/2022
 *
 *
 * @name HttpClientHelper
 * @description
 * “* Wraps http client functionality to avoid directly using a third party npm package
 like axios
 * and simplify replacement in the future if such npm package would stop being developed or other reasons
 */

import axios, { AxiosRequestConfig, AxiosResponse, AxiosError, AxiosRequestHeaders } from 'axios'

import { IHttpRequestParams } from '@/models/http-client/HttpRequestParams.interface'
import { IHttpClient } from '@/models/http-client/HttpClient.interface'
import { RuntimeHeaderParamsInterface } from '@/models/configs/configs.interface'
import { RuntimeConfigsInterface } from '@/models/configs/configs.interface'
export class HttpClientHelper implements IHttpClient {
  options: {
    baseURL: string
    headers: RuntimeHeaderParamsInterface & { 'Content-Type': string; 'request-channel': string; _channel: string } & AxiosRequestHeaders
  }
  constructor(config: AxiosRequestConfig) {
    this.options = {
      baseURL: config.baseURL || '',
      headers: Object.assign({}, config.headers || {}, {
        _channel: 'web',
        'Content-Type': 'application/json',
        'request-channel': 'ZERO_WIDGET'
      })
    }
  }
  get<T>(parameters: IHttpRequestParams, runtimeConfigs: RuntimeConfigsInterface): Promise<T> {
    const { userToken: token } = runtimeConfigs || ''
    const { runtimeHeaderParams: headers, baseUrl } = runtimeConfigs
    this.options.headers = {
      ...this.options.headers,
      ...headers
    }
    this.options.baseURL = baseUrl
    return new Promise<T>((resolve, reject) => {
      const { path } = parameters
      this.options.headers.Authorization = `Bearer ${token}`
      const options: AxiosRequestConfig = {
        ...this.options
      }
      if (parameters.queryParams) {
        options.params = parameters.queryParams
      }
      axios
        .get(path, options)
        .then((response: AxiosResponse) => {
          resolve(response.data as T)
        })
        .catch((response: AxiosResponse) => {
          console.info('------ rejecting ----')
          reject(response)
        })
    })
  }

  post<T>(parameters: IHttpRequestParams, runtimeConfigs: RuntimeConfigsInterface): Promise<T> {
    const { userToken: token } = runtimeConfigs || ''
    const { runtimeHeaderParams: headers, baseUrl } = runtimeConfigs
    this.options.headers = {
      ...this.options.headers,
      ...headers
    }
    this.options.baseURL = baseUrl
    return new Promise<T>((resolve, reject) => {
      const { path, payload } = parameters
      this.options.headers.Authorization = `Bearer ${token}`

      // axios options
      const options: AxiosRequestConfig = {
        ...this.options
      }
      if (parameters.queryParams) {
        options.params = parameters.queryParams
      }
      return axios
        .post(path, payload, options)
        .then((response: AxiosResponse) => {
          resolve(response.data as T)
        })
        .catch((response: AxiosError) => {
          reject(response)
        })
    })
  }

  put<T>(parameters: IHttpRequestParams): Promise<T> {
    return new Promise<T>((resolve, reject) => {
      const { path, payload } = parameters

      // axios options
      const options: AxiosRequestConfig = {
        ...this.options
      }
      if (parameters.queryParams) {
        options.params = parameters.queryParams
      }
      axios
        .put(path, payload, options)
        .then((response: AxiosResponse) => {
          resolve(response.data as T)
        })
        .catch((response: AxiosResponse) => {
          reject(response)
        })
    })
  }
}
